import React, { forwardRef, useEffect } from 'react';
import { createPortal } from 'react-dom';

import './dynamic-react-portal.scss';

interface DynamicReactPortalProps {
    portalId: string;
    children: JSX.Element;
}

export const DynamicReactPortal = forwardRef(function (
    { portalId, children }: DynamicReactPortalProps,
    portalRef: React.MutableRefObject<HTMLElement>,
): React.ReactPortal {
    useEffect(() => {
        portalRef.current = document.getElementById(portalId);

        if (!portalRef.current) {
            portalRef.current = document.createElement('div');
            portalRef.current.id = portalId;
            portalRef.current.dataset.testId = portalId;
            portalRef.current.className = 'dynamic-react-portal';
            document.body.appendChild(portalRef.current);
        }
    }, []);

    if (!portalRef.current) {
        return null;
    }

    return createPortal(
        <div id={`${portalId}__container`} className="dynamic-react-portal__container">
            {children}
        </div>,
        portalRef.current,
    );
});
